import { TYPE_COLLECTION } from './input-types';

export const id = 'customer';
export const apiKey = 'CustomerId';
export const type = TYPE_COLLECTION;

export const customer = {
  id,
  apiKey,
  type,
};
